import React from 'react'
import './About.css'
import guitarra from '../../img/guitarra.jpg'
function About() {
    return (
        <div className="a">
            <div className="a-left">
                <div className="a-card bg"></div>
                <div className="a-card">
                    <img src={guitarra} alt="" className="a-image"></img>
                </div>
            </div>
            <div className="a-right">
                <h1 className="a-title">About Me</h1>
                <p className="a-sub">
                    Guitarrist, singer, music productor, streamer, content creator and web developer
                </p>
                <p className="a-desc">
                    12 years of experience in music and music production who recently falls in love with
                    web development technology and software. I make streams on Twitch.
                    Yes, that guitar is mine. Always learning, always working.
                </p>
            </div>
        </div>
    )
}

export default About